import { useCallback } from "react";
import { NavigateOptions, To, useNavigate, useParams } from "react-router";
import { localizeTo } from "../components/links/utils";
import { DEFAULT_LANGUAGE } from "../utils/language";

export const useLocalizedNavigate = () => {
  const navigate = useNavigate();
  const { lang = DEFAULT_LANGUAGE } = useParams();

  return useCallback(
    (to: To | number, options?: NavigateOptions) => {
      if (typeof to === "number") {
        navigate(to);
        return;
      }

      if (
        typeof to === "string" &&
        (to.startsWith("http://") ||
          to.startsWith("https://") ||
          to.startsWith("//"))
      ) {
        window.location.assign(to);
        return;
      }

      navigate(localizeTo(to, lang), options);
    },
    [navigate, lang],
  );
};
